import { useState } from 'react';

import DistributionSelect from 'entities/Charts/components/DistributionSelect';
import { BAR_CHART_HEIGHT, BAR_CHART_WIDTH } from 'entities/Charts/constants';
import {
  ChartFilterProps,
  useSubmissionsVolumeChartData
} from 'entities/Charts/sdk';

import BarChart from 'components/BarChart';

const SubmissionsVolumeChart = ({ filters }: { filters: ChartFilterProps }) => {
  const [distributionOption, setDistributionOption] = useState<string>('grade');

  const { data, isLoading } = useSubmissionsVolumeChartData({
    option: distributionOption,
    filters
  });

  return (
    <>
      {isLoading && (
        <BarChart
          loading
          series={[]}
          height={BAR_CHART_HEIGHT}
          width={BAR_CHART_WIDTH}
        />
      )}

      {!isLoading && (
        <BarChart
          dataset={data as readonly Record<string, any>[]}
          height={BAR_CHART_HEIGHT}
          width={BAR_CHART_WIDTH}
          xAxis={[{ dataKey: 'group_field_value' }]}
          yAxis={[{ dataKey: 'submission_volume', width: 60 }]}
          series={[
            {
              dataKey: 'submission_volume',
              label: 'Submission Volume'
            }
          ]}
          margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
          localeText={{ noData: 'No data for selected filters' }}
        />
      )}

      <DistributionSelect
        distributionOption={distributionOption}
        setDistributionOption={setDistributionOption}
      />
    </>
  );
};

export default SubmissionsVolumeChart;
